import { Directive } from '@angular/core';

@Directive({
  selector: '[appItemContainer]'
})
export class ItemContainerDirective {}
